import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../../../assets/images/chat/search-icon.svg'
import _imports_1 from '../../../../../assets/images/chat/edit-icon.svg'


const _hoisted_1 = {
  id: "family-portal-sidenav",
  class: "overflow-hidden"
}
const _hoisted_2 = { class: "list-group-flush h-100 overflow-hidden d-flex flex-column" }
const _hoisted_3 = { class: "nav-item list-group-item message-list-itemm nav-list-header calls-list-header" }
const _hoisted_4 = { class: "d-flex align-items-center h-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold mb-0 ms-2 text-app-secondary" }, "Channels", -1 /* HOISTED */)
const _hoisted_6 = { class: "ms-auto d-flex gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "nav-item list-group-item message-list-item"
}
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = { class: "input-group-append cursor-pointer" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times dialog-close text-secondary font-size-sm" }, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "nav-item list-group-item message-list-itemm nav-list-header groups-section"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center h-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-bold mb-0 ms-2 text-dark groups-title" }, "Groups"),
  /*#__PURE__*/_createElementVNode("div", { class: "ms-auto d-flex gap-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h font-size-lg ms-3 pt-1 ps-1 cursor-pointer" })
  ])
], -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "nav-item list-group-item groups-item"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "fw-bold mb-0 ms-2 text-primary fw-bold" }
const _hoisted_18 = {
  key: 0,
  class: "ms-auto d-flex gap-3"
}
const _hoisted_19 = { class: "threads-count text-primary fw-bold" }
const _hoisted_20 = {
  key: 3,
  class: "nav-item list-group-item selected-group"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center h-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 ms-2" }, "Results")
], -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 4,
  class: "nav-item list-group-item selected-group"
}
const _hoisted_24 = { class: "d-flex align-items-center h-100" }
const _hoisted_25 = { class: "mb-0 ms-2" }
const _hoisted_26 = ["id", "onClick"]
const _hoisted_27 = {
  key: 0,
  class: "d-flex align-items-center min-width-0"
}
const _hoisted_28 = { class: "ps-2 flex-grow-1 min-width-0" }
const _hoisted_29 = { class: "d-flex align-items-center justify-content-between conversation-header-row" }
const _hoisted_30 = { class: "mb-1 text-black conversation-patient-name" }
const _hoisted_31 = { class: "text-dark conversation-time" }
const _hoisted_32 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_33 = { class: "text-truncate me-2 mb-1 text-dark" }
const _hoisted_34 = { class: "weight-600 blue-text" }
const _hoisted_35 = {
  key: 1,
  class: "d-flex align-items-center min-width-0"
}
const _hoisted_36 = { class: "d-flex align-items-center justify-content-between conversation-header-row" }
const _hoisted_37 = { class: "mb-1 text-dark conversation-patient-name" }
const _hoisted_38 = { class: "text-dark conversation-time" }
const _hoisted_39 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_40 = { class: "text-truncate me-2 text-dark" }
const _hoisted_41 = { class: "py-1" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "loader-parent" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "msg-loader" })
], -1 /* HOISTED */)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 5,
  class: "nav-item list-group-item text-dark h-100 d-flex justify-content-center text-center flex flex-column"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h5", null, "No Conversations Found.", -1 /* HOISTED */)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  class: "flex-grow-1 overflow-auto",
  style: {"min-height":"0"}
}
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"ava-initials me-1\"><span></span></div><div class=\"ms-2 flex-grow-1\"><span class=\"shimmer-loading w-90 lighten\"></span><div class=\"message-content\"><span class=\"shimmer-loading w-60 lighten\"></span></div></div></div>", 1)
const _hoisted_49 = [
  _hoisted_48
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("img", {
              class: "cursor-pointer",
              src: _imports_0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSearchBox(true)))
            }, null, 512 /* NEED_PATCH */), [
              [_directive_tooltip, { title: `Search`, placement: 'left' }]
            ]),
            (_ctx.hasFamilyPortalEditPermission)
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "cursor-pointer",
                  src: _imports_1,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToNewConversation && _ctx.navigateToNewConversation(...args)))
                }, null, 512 /* NEED_PATCH */)), [
                  [_directive_tooltip, { title: `New Chat`, placement: 'left' }]
                ])
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      (_ctx.openSearch)
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control border-end-0",
                placeholder: "Patient Name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.term) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.term],
                [_directive_focus]
              ]),
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("div", {
                  class: "input-group-text bg-transparent px-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSearchBox(false)))
                }, _hoisted_11)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.showTermSearchUi)
        ? (_openBlock(), _createElementBlock("li", _hoisted_12, _hoisted_14))
        : _createCommentVNode("v-if", true),
      (_ctx.conversationGroupsCount && !_ctx.showTermSearchUi)
        ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.GroupTypeEnum), ([key, value]) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                (_ctx.hasGroupPermission(value.value))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["d-flex align-items-center cursor-pointer py-1 px-2", { 'group-selected-active': value.value == _ctx.selectedGroupType }]),
                      onClick: ($event: any) => (_ctx.onGroupSelected(value.value))
                    }, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(value.name), 1 /* TEXT */),
                      (_ctx.conversationGroupsCount && _ctx.conversationGroupsCount[key] > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.conversationGroupsCount[key]), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_16))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.showTermSearchUi)
        ? (_openBlock(), _createElementBlock("li", _hoisted_20, _hoisted_22))
        : (_ctx.selectedGroupType)
          ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.GroupTypeEnum.getKeyUsingValue(_ctx.selectedGroupType)) + " Group", 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
      _withDirectives(_createElementVNode("div", {
        ref: "conversationListContainer",
        class: _normalizeClass(["overflow-auto scroll-paginate flex-grow-1", { 'custom-scrollbar': _ctx.userOs == 'Windows' }]),
        style: {"min-height":"0"}
      }, [
        ((!_ctx.isLoading || _ctx.pageNumber > 1) && _ctx.groupConversations?.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.groupConversations, (conversation, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: conversation.id,
                id: `conversation-${conversation.id}`,
                class: _normalizeClass(["nav-item list-group-item message-list-item cursor-pointer", {
                            active: _ctx.selectedConversation.id == conversation.id
                        }]),
                onClick: ($event: any) => (_ctx.handleConversationSelection(conversation, index))
              }, [
                (_ctx.showTermSearchUi)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["ava-initials flex-shrink-0 me-1", `ava-initials-${_ctx.getSolutionClassIndex(index)}`])
                      }, _toDisplayString(_ctx.formatUserInitials(conversation.patient)), 3 /* TEXT, CLASS */),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatDisplayUsers([conversation.patient])), 1 /* TEXT */)
                          ]),
                          _createElementVNode("small", _hoisted_31, _toDisplayString(_ctx.formatDateToLocalBasedOnDayMode(conversation.modifiedOn, true)), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatDisplayMessage(
                                                _ctx.sanitizeMarkup(_ctx.markdownToHtml(conversation.lastThread.body))
                                            )), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.GroupTypeEnum.getKeyUsingValue(conversation.conversationGroupType)), 1 /* TEXT */)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["ava-initials flex-shrink-0 me-1", `ava-initials-${_ctx.getSolutionClassIndex(index)}`])
                      }, _toDisplayString(_ctx.formatUserInitials(conversation.patient)), 3 /* TEXT, CLASS */),
                      _createElementVNode("div", {
                        class: _normalizeClass(["ps-2 flex-grow-1 min-width-0", {
                                    'fw-bold': conversation.hasNewThreads
                                }])
                      }, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("span", _hoisted_37, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatDisplayUsers([conversation.patient])), 1 /* TEXT */)
                          ]),
                          _createElementVNode("small", _hoisted_38, _toDisplayString(_ctx.formatDateToLocalBasedOnDayMode(conversation.lastThread.modifiedOn, true)), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createCommentVNode(" :class=\"{\r\n                                        'fw-bold': message?.unread > 0,\r\n                                        'text-dark': !(message?.unread > 0)\r\n                                    }\" "),
                            _createTextVNode(_toDisplayString(_ctx.formatDisplayMessage(
                                                _ctx.sanitizeMarkup(_ctx.markdownToHtml(conversation.lastThread.subject))
                                            )), 1 /* TEXT */)
                          ])
                        ])
                      ], 2 /* CLASS */)
                    ]))
              ], 10 /* CLASS, PROPS */, _hoisted_26))
            }), 128 /* KEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createElementVNode("li", _hoisted_41, _hoisted_43, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.isLoadingMoreConversations && _ctx.pageNumber > 1]
        ])
      ], 2 /* CLASS */), [
        [_vShow, (!_ctx.isLoading || _ctx.pageNumber > 1) && _ctx.groupConversations?.length > 0]
      ]),
      (!_ctx.isLoading && _ctx.groupConversations?.length == 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_44, _hoisted_46))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_47, [
        (_ctx.isLoading && _ctx.pageNumber < 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
              return _createElementVNode("li", {
                key: i,
                class: "nav-item list-group-item d-flex justify-content-center text-middle flex flex-column"
              }, _hoisted_49)
            }), 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}